import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { interpret as interpretAbundancia } from '../../consultas/abundancia/functions'
import { interpret as interpretAtraccion } from '../../consultas/atraccion/functions'
import { interpret as interpretAutoconocimiento } from '../../consultas/autoconocimiento/functions'
import { interpret as interpretCelta } from '../../consultas/celta/functions'
import { interpret as interpretEvolutivo } from '../../consultas/evolutivo/functions'
import { interpret as interpretExPareja } from '../../consultas/ex-pareja/functions'
import { interpret as interpretFuturo } from '../../consultas/futuro/functions'
import { interpret as interpretGral } from '../../consultas/gral/functions'
import { interpret as interpretInfidelidad } from '../../consultas/infidelidad/functions'
import { interpret as interpretLove } from '../../consultas/love/functions'
import { interpret as interpretProteccion } from '../../consultas/proteccion/functions'
import { interpret as interpretRenacer } from '../../consultas/renacer/functions'
import { interpret as interpretTrabajo } from '../../consultas/trabajo/functions'
import { interpret as interpretVidaPasada } from '../../consultas/vida-pasada/functions'

export type SpreadInterpretFn = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => { consult: string; [key: string]: unknown }

export type FlexibleSpreadDef = {
    id: string
    title: string
    shortTitle: string
    cardCount: number
    requiresPersonalityNumerology?: boolean
    /** Tirada del Amor: elige modalidad 1–6 en el wizard */
    isLoveMultimodal?: boolean
    /** Requiere datos del consultado (ex, vínculo, etc.) */
    needsConsultado?: boolean
    interpret: SpreadInterpretFn
}

/**
 * Lecturas del menú Consultas (sin Preguntas, sin Especiales, sin Compatibilidad/Gratis/Manual/Mejor año).
 */
export const FLEXIBLE_SPREADS: FlexibleSpreadDef[] = [
    {
        id: 'amor',
        title: 'Tirada del Amor',
        shortTitle: 'Amor',
        cardCount: 10,
        isLoveMultimodal: true,
        interpret: interpretLove as unknown as SpreadInterpretFn,
    },
    {
        id: 'ex-pareja',
        title: 'Ex Pareja',
        shortTitle: 'Ex Pareja',
        cardCount: 14,
        needsConsultado: true,
        requiresPersonalityNumerology: true,
        interpret: interpretExPareja as unknown as SpreadInterpretFn,
    },
    {
        id: 'general',
        title: 'Tirada General',
        shortTitle: 'General',
        cardCount: 25,
        requiresPersonalityNumerology: true,
        interpret: interpretGral,
    },
    {
        id: 'celta',
        title: 'Cruz Celta',
        shortTitle: 'Cruz Celta',
        cardCount: 10,
        interpret: interpretCelta as unknown as SpreadInterpretFn,
    },
    {
        id: 'vidapasada',
        title: 'Vida Pasada',
        shortTitle: 'Vida Pasada',
        cardCount: 25,
        requiresPersonalityNumerology: true,
        interpret: interpretVidaPasada as SpreadInterpretFn,
    },
    {
        id: 'evolutivo',
        title: 'Tarot Evolutivo',
        shortTitle: 'Evolutivo',
        cardCount: 14,
        requiresPersonalityNumerology: true,
        interpret: interpretEvolutivo,
    },
    {
        id: 'proteccion',
        title: 'Protección y Energía',
        shortTitle: 'Protección',
        cardCount: 7,
        interpret: interpretProteccion,
    },
    {
        id: 'abundancia',
        title: 'Abundancia y Prosperidad',
        shortTitle: 'Abundancia',
        cardCount: 10,
        interpret: interpretAbundancia,
    },
    {
        id: 'trabajo',
        title: 'Lectura Laboral',
        shortTitle: 'Laboral',
        cardCount: 10,
        interpret: interpretTrabajo,
    },
    {
        id: 'infidelidad',
        title: 'Lectura de Infidelidad',
        shortTitle: 'Infidelidad',
        cardCount: 10,
        interpret: interpretInfidelidad,
    },
    {
        id: 'futuro',
        title: 'Lectura del Futuro',
        shortTitle: 'Futuro',
        cardCount: 10,
        interpret: interpretFuturo,
    },
    {
        id: 'autoconocimiento',
        title: 'Autoconocimiento Profundo',
        shortTitle: 'Autoconocimiento',
        cardCount: 10,
        interpret: interpretAutoconocimiento,
    },
    {
        id: 'atraccion',
        title: 'Atracción Magnética',
        shortTitle: 'Atracción',
        cardCount: 10,
        interpret: interpretAtraccion,
    },
    {
        id: 'renacer',
        title: 'Renacer del Propósito',
        shortTitle: 'Renacer',
        cardCount: 26,
        requiresPersonalityNumerology: true,
        interpret: interpretRenacer,
    },
]

export const getFlexibleSpread = (id: string): FlexibleSpreadDef | undefined =>
    FLEXIBLE_SPREADS.find((s) => s.id === id)

export const LOVE_TIPOS_NEED_CONSULTADO = ['2', '3', '5', '6']
